
export default {
  name: 'BaseProfileAuthorRecommendationsLight',
  props: {
    author: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      recommendations: [],
      recommendationsCount: 0,
    }
  },
  async fetch() {
    await this.fetchRecommendations()
  },
  methods: {
    openRecommendationPopUp() {
      this.$refs.createRecommendation.open()
    },
    async fetchRecommendations() {
      const { recommendations, countAllPublishedRecommendations } =
        await this.$axios.$get(
          `/recommendations/all/${this.author._id || this.author.id}`,
          {
            params: {
              limit: 3,
              offset: 0,
            },
          }
        )

      this.recommendationsCount = countAllPublishedRecommendations
      this.recommendations = recommendations
    },
  },
}
